export default __webpack_public_path__ + "static/assets/im_log_query.b5ef220544d77052f39f39afca815b76.png";